import { render } from "./AppTabs.vue?vue&type=template&id=ef11f4ce&scoped=true"
import script from "./AppTabs.vue?vue&type=script&lang=js"
export * from "./AppTabs.vue?vue&type=script&lang=js"

import "./AppTabs.vue?vue&type=style&index=0&id=ef11f4ce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ef11f4ce"

export default script